import { addAlert } from '../MsgNotify/msgNotifyActions';
require('isomorphic-fetch');

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export function loginRequest(){
    return {
        type: LOGIN_REQUEST
    }
}

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export function loginSuccess() {
    return {
        type: LOGIN_SUCCESS
    };
}

export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export function loginFailure() {
    return {
        type: LOGIN_FAILURE
    };
}

export const USER_AUTH_UPDATE = "USER_AUTH_UPDATE";
export const userAuthUpdate = (authObj, username) => {
    return {
        type: USER_AUTH_UPDATE,
        authObject: authObj,
        username: username
    }
}

export function attemptLogin(username, password) {
return (dispatch) => {
    dispatch(loginRequest());
    return fetch('REPLACE', {
        method: 'post',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: 'grant_type=password&username='+username+'&password='+password
    })
    .then(response => {
        if (response.status >= 400) {
            throw new Error("Bad response from server");
        }
        return response.json();
    })
    .then(json => {
        dispatch(userAuthUpdate(json, username))
        dispatch(loginSuccess())
    })
    .catch(() => {
        dispatch(loginFailure());
        dispatch(addAlert("Løn-nr og adgangskode passer ikke sammen"))
    })
  }
}


// WEBPACK FOOTER //
// ./src/App/Login/authenticationActions.js